import util from '@bmp-vue/core/api/util'

const controller = 'ControleEndpoint'

export default Object.assign({}, util.GetCrud(controller, null), {
  Inserir(payload) {
    return util.Axios.Post(controller, payload)
  },

  Obter(codigo) {
    return util.Axios.Get(`${controller}/${codigo}`)
  },

  ObterPorDescricao(nome) {
    return util.Axios.Get(`${controller}/${encodeURIComponent(nome)}`)
  },

  Todos(params) {
    return util.Axios.GetParams(`${controller}/Todos`, params)
  },

  Atualizar(payload) {
    return util.Axios.Put(controller, '', payload)
  },

  Remover(codigo) {
    return util.Axios.Delete(`${controller}/${codigo}`)
  },
})
